(function () {
  let loaded = false;

  function load(src) {
    return new Promise(r => {
      const s = document.createElement('script');
      s.src = src;
      s.defer = true;
      s.onload = r;
      document.head.appendChild(s);
    });
  }

  async function start() {
    if (loaded) return;
    loaded = true;

    const scripts = window.__THIRD_PARTY__ || [];
    for (const src of scripts) {
      try { await load(src); } catch(e){}
    }
  }

  ['click','scroll','touchstart','mousemove','keydown'].forEach(e =>
    window.addEventListener(e, start, { once:true, passive:true })
  );

  // Safety fallback
  setTimeout(start, 4000);
})();
